"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUserMessageTemplates = void 0;

var _reactRedux = require("react-redux");

var _react = require("react");

var _userMessageTemplates = require("../store/entities/userMessageTemplates/userMessageTemplates.selectors");

var _userMessageTemplates2 = require("../store/entities/userMessageTemplates/userMessageTemplates.actions");

var useAll = function useAll() {
  return (0, _reactRedux.useSelector)(_userMessageTemplates.getUserMessageTemplatesAll);
};

var useUserMessageTemplates = function useUserMessageTemplates() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      queryParams = _ref.queryParams;

  var dispatch = (0, _reactRedux.useDispatch)();
  var isIdle = (0, _reactRedux.useSelector)(_userMessageTemplates.getIsUserMessageTemplatesIdle);
  var isFulfilled = (0, _reactRedux.useSelector)(_userMessageTemplates.getIsUserMessageTemplatesFulfilled);
  var isPending = (0, _reactRedux.useSelector)(_userMessageTemplates.getIsUserMessageTemplatesPending);
  (0, _react.useEffect)(function () {
    if (isIdle) {
      dispatch((0, _userMessageTemplates2.fetchMessageTemplates)({
        queryParams: queryParams || {}
      }));
    }
  }, [isIdle, dispatch, queryParams]);
  return (0, _react.useMemo)(function () {
    return {
      isIdle,
      isFulfilled,
      isPending,
      useAll
    };
  }, [isIdle, isFulfilled, isPending]);
};

exports.useUserMessageTemplates = useUserMessageTemplates;